<mat-toolbar class="main-header">
  <button mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>Clasificación de grupos</span>
</mat-toolbar>

<main class="group-standings-page">
  @if (loading) {
    <div class="page-state">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  } @else if (loadFailed) {
    <div class="page-state page-state--message">
      <mat-icon>cloud_off</mat-icon>
      <p>No se ha podido cargar la clasificación.</p>
      <button mat-stroked-button type="button" (click)="retry()">
        Reintentar
      </button>
    </div>
  } @else if (standings.length === 0) {
    <div class="page-state page-state--message">
      <mat-icon>leaderboard</mat-icon>
      <p>Todavía no hay clasificaciones disponibles.</p>
    </div>
  } @else {
    <div class="groups-grid">
      @for (standing of standings; track standing.group) {
        <section class="group-card">
          <h2>
            <span>{{ getGroupName(standing.group) }}</span>
            @if (isGroupLive(standing)) {
              <span class="live-badge">
                <span class="live-dot"></span>
                En vivo
              </span>
            }
          </h2>

          <div class="standing-header" aria-hidden="true">
            <span class="position"></span>
            <span class="team">Selección</span>
            <span>PJ</span>
            <span>DG</span>
            <span>Pts</span>
          </div>

          @for (row of standing.table; track row.team.id) {
            <div class="standing-row" [class.is-live]="isTeamLive(row.team.id)">
              <span class="position">{{ row.position }}</span>
              <span class="team">
                <img [src]="row.team.crest" [alt]="row.team.name" />
                <span>{{ row.team.shortName || row.team.name }}</span>
                @if (isTeamLive(row.team.id)) {
                  <span class="team-live-dot" title="Partido en vivo"></span>
                }
              </span>
              <span>{{ row.playedGames }}</span>
              <span>{{ getGoalDifference(row) }}</span>
              <strong>{{ row.points }}</strong>
            </div>
          }
        </section>
      }
    </div>

    <p class="data-source">Datos proporcionados por football-data.org</p>
  }
</main>
